import React, { useState } from 'react';
import Opensea from '../icon/opensea-icon.svg';
import { useMemo } from 'react';
import { Dialog } from '@headlessui/react';
import { LeftRightArrows, CloseFullscreenModal } from './ImageModalButtons';
import { Media } from './Media';
import { CollectionImage } from 'logic/images';

export default function ImageModal({
  collectionImages,
  displayIdx,
  setDisplayIdx,
  setShowModal,
}: {
  collectionImages: CollectionImage[];
  displayIdx: number;
  setDisplayIdx: (idx: number) => void;
  setShowModal: (s: number | null) => void;
}) {
  const [hasError, setHasError] = useState(false);
  const currentImage = useMemo(
    () => collectionImages[displayIdx],
    [displayIdx, collectionImages]
  );

  return (
    <>
      <Dialog
        className="fixed inset-0 z-50 overflow-y-auto h-full w-full bg-white"
        open={displayIdx != null}
        onClose={() => setShowModal(null)}
      >
        <div className="relative inset-0 grid grid-cols-1 sm:grid-cols-4 sm:gap-3 h-max-full w-full h-full">
          <div className="sm:col-span-3 m-4 relative">
            <div className="visible sm:invisible sm:h-0">
              <CloseFullscreenModal setShowModal={setShowModal} />
            </div>
            <Media
              key={currentImage.imagePath}
              src={
                hasError
                  ? currentImage.metadataImagePath
                  : currentImage.imagePath
              }
              type={currentImage.type}
              onError={() => {
                setHasError(true);
              }}
              priority
              className="m-auto h-fit sm:h-screen object-contain"
              layout="fill"
            />
          </div>
          <div className="sm:col-span-1">
            <div className="h-fit sm:flex-col sm:h-full sm:relative">
              <div className="invisible h-0 sm:visible sm:h-fit">
                <CloseFullscreenModal setShowModal={setShowModal} />
              </div>
              <div className="visible sm:invisible sm:h-0 flex justify-end">
                <LeftRightArrows
                  displayIdx={displayIdx}
                  setDisplayIdx={setDisplayIdx}
                  maxLength={collectionImages.length - 1}
                />
              </div>
              <div className="text-left text-black px-4 sm:absolute sm:bottom-0">
                <p className="font-bold">
                  {currentImage.imageName || 'PLACEHOLDER FOR NAME'}
                </p>
                {currentImage.imageAttributes.map(({ trait_type, value }) => (
                  <p className="text-gray-600" key={trait_type}>
                    {value}
                  </p>
                ))}

                {/* <a>Claim Image</a> */}
                <div className="my-6 text-gray-600 flex flex-wrap">
                  {/* <div className="pr-3 flex align-items-center">
                    <a
                      href={currentImage.etherscan}
                      className="inline-flex hover:opacity-50"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Etherscan className="fill-current w-6 h-6 mr-2" /> View
                      on Etherscan
                    </a>
                  </div> */}
                  {!!currentImage.opensea && (
                    <div className="pr-3 flex align-items-center">
                      <a
                        href={currentImage.opensea}
                        className="inline-flex hover:opacity-50"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Opensea className="fill-current w-6 h-6 mr-2" /> View
                        on Opensea
                      </a>
                    </div>
                  )}
                  {/* <div className="pr-3 flex align-items-center"> */}
                  {/* HACK: hardcoded CID for arweave images */}
                  {/* <a
                      href={`https://arweave.net/yLSFnz4pNo0vsTFZIOf9vmEPu0pZQELXFsSjU8LGTtE/${currentImage.tokenId}.jpg`}
                      className="inline-flex hover:opacity-50"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Arweave className="fill-current w-6 h-6 mr-2 mt-1" />{" "}
                      View on Arweave
                    </a> */}
                  {/* </div> */}
                </div>
                <div className="invisible sm:visible">
                  <LeftRightArrows
                    displayIdx={displayIdx}
                    setDisplayIdx={setDisplayIdx}
                    maxLength={collectionImages.length - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
